import axios from "axios";

// A dedicated axios instance for Employee Connect (really the "Education"
// app — MyM's nav just relabels it), same convention as Cleaning Audit,
// Laundry Audit and Work Scheduler: pointed directly at the real backend
// (MajesticERP-ToolboxAPI), bypassing MajesticERP-EducationWeb's own client
// entirely. Unlike those three, the real backend here is plain Express (not
// restify) with CORS registered via the standard `cors` middleware — no
// restify preflight-405 risk, confirmed by reading its index.js directly.
//
// This deliberately does NOT share MyM's own client (src/utils/interceptors/axios.js)
// or its errorInterceptor, which clears localStorage and redirects to /login on
// any 401+ — an Employee-Connect-only auth hiccup must never log the whole app out.
const educationClient = axios.create({
  baseURL: process.env.REACT_APP_EDU_API_URL,
  headers: {
    "content-type": "application/json",
    accept: "application/json",
  },
});

export default educationClient;
